/**
 * @file dataUpload.js
 * @description Service for uploading CSV files to the backend.
 *              Handles file validation, form data preparation, and API calls.
 *
 * @module dataUpload
 *
 * @exports uploadCsvFile - Function to upload a CSV file with campaign and user details.
 */
/**
 * Uploads a CSV file for a specific campaign.
 * @param {Object} params - The parameters for the upload.
 * @param {File} params.file - The CSV file to upload.
 * @param {number} params.campaignId - The ID of the campaign.
 * @param {number} params.userId - The ID of the user.
 * @param {number} params.conversationMode - The conversation mode.
 * @returns {Promise<Object>} The response data from the server.
 * @throws {Error} If the file or campaign ID is missing, or if the upload fails.
 */

import { DATA_UPLOAD_ERRORS } from "../../common/constants/dataModule/dataUploadContstant";

import {  DATA_UPLOAD_URLS } from "../apiConfig";
import apiClient from "../apiInstance";

export const uploadCsvFile = async ({ file, campaignId, userId, conversationMode }) => {
  try {
    if (!file) throw new Error("Missing CSV file.");
    if (!campaignId) throw new Error("Missing campaignId.");

    const formData = new FormData();
    formData.append("file", file); // field name must match backend: upload.single("file")
    formData.append("campaignId", String(campaignId));
    formData.append("userId", String(userId));
    formData.append("conversationMode", String(conversationMode));
  // keep signature minimal; UI-only radio selection is not forwarded by default

    // choose endpoint based on conversationMode
    const mode = Number(conversationMode);
    let endpoint = DATA_UPLOAD_URLS.UPDATE_UPLOAD_CSV; // default (mode 2)

    const response = await apiClient.post(endpoint, formData, { headers: {} });

    return response.data;
  } catch (error) {
    console.error(
      DATA_UPLOAD_ERRORS.UPLOAD_CSV_ERROR,
      error.response?.data || error.message
    );
    throw error;
  }
};